export var DENSITIES = [1, 2];